import { Icon, Stack, Typography } from "@storoey/sui";
import { Show } from "solid-js";
import { TaskDto } from "../../backend/models/dto/Item.dto";
import styles from "./TaskButton.module.scss";

export const TaskButton = (props: {
  task: TaskDto;
  onUpdate: (data: {
    id: number;
    status: TaskDto["status"];
    overrideId?: number;
  }) => void;
  onShowRecording: (id: number) => void;
  onShowPhoto: (id: number) => void;
}) => {
  const handleToggleClick = () => {
    const newStatus =
      props.task.status === null
        ? "valid"
        : props.task.status === "valid"
          ? "invalid"
          : null;

    props.onUpdate({
      id: props.task.id,
      status: newStatus,
      overrideId: props.task.overrideId,
    });
  };

  const handleRecordingClick = () => {
    props.onShowRecording(props.task.id);
  };

  const handlePhotoClick = () => {
    props.onShowPhoto(props.task.id);
  };

  return (
    <div class={styles["container"]}>
      <button
        type="button"
        onClick={handleToggleClick}
        classList={{
          [styles["toggle"]]: true,
          [styles[`status-${props.task.status}`]]: props.task.status !== null,
        }}
      >
        <Typography variant="button-tiny" wrap={false}>
          {props.task.prefix}
        </Typography>
        <Typography variant="button-medium" wrap={false}>
          {props.task.content}
        </Typography>
      </button>
      <div class={styles["actions"]}>
        <button
          type="button"
          class={styles["action"]}
          onClick={handleRecordingClick}
        >
          <Stack direction="row" align="center">
            <Icon>mic</Icon>
            <div style={{ flex: 1 }}>
              <Typography variant="button-medium">Opptak</Typography>
            </div>
            <Show when={props.task.recordings.length > 0}>
              <Typography variant="button-small">
                ({props.task.recordings.length})
              </Typography>
            </Show>
          </Stack>
        </button>
        <button
          type="button"
          class={styles["action"]}
          onClick={handlePhotoClick}
        >
          <Stack direction="row" align="center">
            <Icon>photo</Icon>
            <div style={{ flex: 1 }}>
              <Typography variant="button-medium">Bilder</Typography>
            </div>
            <Show when={props.task.photos.length > 0}>
              <Typography variant="button-small">
                ({props.task.photos.length})
              </Typography>
            </Show>
          </Stack>
        </button>
      </div>
    </div>
  );
};
